import { AbstractBreezeViewComponent } from '@common/classes/breeze-view';
import { VTSPermissions } from '@common/classes/permissions';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@common/services/breeze-view.service";
import * as i2 from "@angular/forms";
import * as i3 from "@fortawesome/angular-fontawesome";
import * as i4 from "@progress/kendo-angular-grid";
import * as i5 from "../../../common/components/action-bar/action-bar.component";
import * as i6 from "../../../common/components/app-control/app-control.component";
import * as i7 from "../../../common/components/loader/loader.component";
import * as i8 from "../../../common/components/content-link-header/content-link-header.component";
import * as i9 from "../../../common/components/app-grid/app-grid.component";
import * as i10 from "@angular/common";
import * as i11 from "@ngx-translate/core";
import * as i12 from "../../../common/pipes/codelist.pipe";
function VesselPermitViewComponent_ng_template_2_ng_template_53_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵelement(1, "fa-icon", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2);
  }
  if (rf & 2) {
    const row_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r1.nmswPermitViewUrl + row_r5.id, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", row_r5.referenceNumber, " ");
  }
}
function VesselPermitViewComponent_ng_template_2_ng_template_56_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r6 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r6.permitTypeId, "PermitType")), " ");
  }
}
function VesselPermitViewComponent_ng_template_2_ng_template_59_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r7 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r7.permitStatusId, "PermitStatus")), " ");
  }
}
function VesselPermitViewComponent_ng_template_2_ng_template_62_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r8 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r8.berthId, "Berth")), " ");
  }
}
function VesselPermitViewComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-content-link-header", 2)(1, "a", 3);
    i0.ɵɵelement(2, "fa-icon", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 5)(4, "div", 6)(5, "div", 7)(6, "div", 8)(7, "app-control", 9);
    i0.ɵɵlistener("ngModelChange", function VesselPermitViewComponent_ng_template_2_Template_app_control_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.model.referenceNumber = $event);
    });
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 8)(10, "app-control", 10);
    i0.ɵɵlistener("ngModelChange", function VesselPermitViewComponent_ng_template_2_Template_app_control_ngModelChange_10_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.model.permitTypeId = $event);
    });
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 8)(13, "app-control", 11);
    i0.ɵɵlistener("ngModelChange", function VesselPermitViewComponent_ng_template_2_Template_app_control_ngModelChange_13_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.model.permitStatusId = $event);
    });
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 12)(16, "app-control", 13);
    i0.ɵɵlistener("ngModelChange", function VesselPermitViewComponent_ng_template_2_Template_app_control_ngModelChange_16_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r13 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r13.model.validFromDate = $event);
    });
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "div", 12)(19, "app-control", 14);
    i0.ɵɵlistener("ngModelChange", function VesselPermitViewComponent_ng_template_2_Template_app_control_ngModelChange_19_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.model.validToDate = $event);
    });
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "div", 8)(22, "app-control", 15);
    i0.ɵɵlistener("ngModelChange", function VesselPermitViewComponent_ng_template_2_Template_app_control_ngModelChange_22_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.model.requestingOrganizationId = $event);
    });
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(24, "div", 7)(25, "div", 12)(26, "app-control", 16);
    i0.ɵɵlistener("ngModelChange", function VesselPermitViewComponent_ng_template_2_Template_app_control_ngModelChange_26_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.model.berthId = $event);
    });
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(28, "div", 12)(29, "app-control", 17);
    i0.ɵɵlistener("ngModelChange", function VesselPermitViewComponent_ng_template_2_Template_app_control_ngModelChange_29_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.model.vtsVesselVisit.portId = $event);
    });
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "div", 12)(32, "app-control", 18);
    i0.ɵɵlistener("ngModelChange", function VesselPermitViewComponent_ng_template_2_Template_app_control_ngModelChange_32_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r18 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r18.model.vtsVesselVisit.vesselId = $event);
    });
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "div", 12)(35, "app-control", 19);
    i0.ɵɵlistener("ngModelChange", function VesselPermitViewComponent_ng_template_2_Template_app_control_ngModelChange_35_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.model.vtsVesselVisit.visitNumber = $event);
    });
    i0.ɵɵpipe(36, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(37, "div", 12)(38, "app-control", 20);
    i0.ɵɵlistener("ngModelChange", function VesselPermitViewComponent_ng_template_2_Template_app_control_ngModelChange_38_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r20 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r20.model.vtsVesselVisit.mswVisitNumber = $event);
    });
    i0.ɵɵpipe(39, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(40, "div", 7)(41, "div", 21)(42, "app-control", 22);
    i0.ɵɵlistener("ngModelChange", function VesselPermitViewComponent_ng_template_2_Template_app_control_ngModelChange_42_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r21 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r21.model.transportMaltaRemarks = $event);
    });
    i0.ɵɵpipe(43, "translate");
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(44, "div", 23)(45, "div", 6)(46, "h5");
    i0.ɵɵtext(47, "Vessel permit versions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "app-grid", 24);
    i0.ɵɵelement(49, "kendo-grid-column", 25);
    i0.ɵɵpipe(50, "translate");
    i0.ɵɵelementStart(51, "kendo-grid-column", 26);
    i0.ɵɵpipe(52, "translate");
    i0.ɵɵtemplate(53, VesselPermitViewComponent_ng_template_2_ng_template_53_Template, 3, 2, "ng-template", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(54, "kendo-grid-column", 28);
    i0.ɵɵpipe(55, "translate");
    i0.ɵɵtemplate(56, VesselPermitViewComponent_ng_template_2_ng_template_56_Template, 3, 6, "ng-template", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(57, "kendo-grid-column", 29);
    i0.ɵɵpipe(58, "translate");
    i0.ɵɵtemplate(59, VesselPermitViewComponent_ng_template_2_ng_template_59_Template, 3, 6, "ng-template", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(60, "kendo-grid-column", 30);
    i0.ɵɵpipe(61, "translate");
    i0.ɵɵtemplate(62, VesselPermitViewComponent_ng_template_2_ng_template_62_Template, 3, 6, "ng-template", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(63, "kendo-grid-column", 31);
    i0.ɵɵpipe(64, "translate");
    i0.ɵɵelement(65, "kendo-grid-column", 32);
    i0.ɵɵpipe(66, "translate");
    i0.ɵɵelement(67, "kendo-grid-column", 33);
    i0.ɵɵpipe(68, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.title)("breadcrumb", ctx_r0.breadcrumb);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r0.nmswPermitViewUrl + ctx_r0.model.id, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(8, 53, "Permit Number"))("ngModel", ctx_r0.model.referenceNumber)("entity", ctx_r0.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(11, 55, "Permit Type"))("ngModel", ctx_r0.model.permitTypeId)("entity", ctx_r0.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(14, 57, "Permit Status"))("ngModel", ctx_r0.model.permitStatusId)("entity", ctx_r0.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(17, 59, "Valid From"))("time", true)("ngModel", ctx_r0.model.validFromDate)("entity", ctx_r0.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(20, 61, "Valid To"))("time", true)("ngModel", ctx_r0.model.validToDate)("entity", ctx_r0.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(23, 63, "Requesting Organization"))("ngModel", ctx_r0.model.requestingOrganizationId)("entity", ctx_r0.model);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(27, 65, "Berth"))("ngModel", ctx_r0.model.berthId)("entity", ctx_r0.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(30, 67, "Port"))("ngModel", ctx_r0.model.vtsVesselVisit.portId)("entity", ctx_r0.model.vtsVesselVisit);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(33, 69, "Vessel Name"))("ngModel", ctx_r0.model.vtsVesselVisit.vesselId)("entity", ctx_r0.model.vtsVesselVisit);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(36, 71, "VTS Visit Number"))("ngModel", ctx_r0.model.vtsVesselVisit.visitNumber)("entity", ctx_r0.model.vtsVesselVisit);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(39, 73, "MSW Visit Number"))("ngModel", ctx_r0.model.vtsVesselVisit.mswVisitNumber)("entity", ctx_r0.model.vtsVesselVisit);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(43, 75, "Remarks By Transport Malta"))("ngModel", ctx_r0.model.transportMaltaRemarks)("entity", ctx_r0.model);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("data", ctx_r0.chainedPermits)("sortable", true)("sort", ctx_r0.gridSort);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(50, 77, "ID"));
    i0.ɵɵproperty("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(52, 79, "Permit Number"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(55, 81, "Permit Type"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(58, 83, "Permit Status"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(61, 85, "Berth"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(64, 87, "MSW Approval Date"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(66, 89, "Valid From"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(68, 91, "Valid To"));
  }
}
export class VesselPermitViewComponent extends AbstractBreezeViewComponent {
  constructor(breezeViewService) {
    super(breezeViewService);
    this.breezeViewService = breezeViewService;
    this.chainedPermits = [];
    this.entityName = 'VesselPermit';
    this.parentRoute = '/vessel-permit';
    this.editPermission = VTSPermissions.Action.edit;
    this.breadcrumb = [{
      icon: 'list',
      title: this.translateService.get('MSW Vessel Permit List'),
      route: '/vessel-permit/list'
    }, {
      icon: 'ship',
      title: this.translateService.get('MSW Vessel Permit')
    }];
    this.gridSort = [{
      field: 'approvalDate',
      dir: 'asc'
    }];
    this.nmswPermitViewUrl = environment.settings.nmswPermitViewUrl;
    this.actionBar.shift();
  }
  get title() {
    return `Vessel permit - ${this.model.referenceNumber}`;
  }
  modelLoaded() {
    super.modelLoaded();
    this.breezeViewService.handleQuery('VesselPermits', {
      id: this.model.id,
      primary: false
    }).then(permits => this.chainedPermits = permits);
  }
}
VesselPermitViewComponent.ɵfac = function VesselPermitViewComponent_Factory(t) {
  return new (t || VesselPermitViewComponent)(i0.ɵɵdirectiveInject(i1.BreezeViewService));
};
VesselPermitViewComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: VesselPermitViewComponent,
  selectors: [["app-vessel-permit-view"]],
  features: [i0.ɵɵProvidersFeature([BreezeViewService]), i0.ɵɵInheritDefinitionFeature],
  decls: 3,
  vars: 2,
  consts: [[3, "items"], [3, "isBusy"], [3, "title", "breadcrumb"], ["target", "_blank", 1, "text-primary", "link-box", "fixed", 3, "href"], ["icon", "arrow-up-right-from-square"], [1, "card", "card-border-top"], [1, "card-body"], [1, "row"], [1, "col"], ["property", "referenceNumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "PermitType", "property", "permitTypeId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "PermitStatus", "property", "permitStatusId", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "col-2"], ["type", "datetime", "property", "validFromDate", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["type", "datetime", "property", "validToDate", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Agent", "property", "requestingOrganizationId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Berth", "property", "berthId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Port", "property", "portId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Vessel", "property", "vesselId", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "visitNumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "mswVisitNumber", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "col-4"], ["property", "transportMaltaRemarks", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "card", "card-border-top", "mt-3"], [3, "data", "sortable", "sort"], ["field", "id", 3, "title", "hidden"], ["field", "referenceNumber", 3, "title"], ["kendoGridCellTemplate", ""], ["field", "permitTypeId", 3, "title"], ["field", "permitStatusId", 3, "title"], ["field", "berth.name", 3, "title"], ["field", "approvalDate", "format", "g", 3, "title"], ["field", "validFromDate", "format", "g", 3, "title"], ["field", "validToDate", "format", "g", 3, "title"]],
  template: function VesselPermitViewComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelement(0, "app-action-bar", 0);
      i0.ɵɵelementStart(1, "app-loader", 1);
      i0.ɵɵtemplate(2, VesselPermitViewComponent_ng_template_2_Template, 69, 93, "ng-template");
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵproperty("items", ctx.actionBar);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("isBusy", !ctx.model);
    }
  },
  dependencies: [i2.NgControlStatus, i2.NgModel, i3.FaIconComponent, i4.ColumnComponent, i4.CellTemplateDirective, i5.ActionBarComponent, i6.AppControlComponent, i7.LoaderComponent, i8.ContentLinkHeaderComponent, i9.AppGridComponent, i10.AsyncPipe, i11.TranslatePipe, i12.CodelistPipe],
  styles: ["\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZVJvb3QiOiIifQ== */"]
});